import { KycStatus } from '@/api/common.types';
import { useCheckStatus } from '@/api/queryHooks/useKycController';

export const useIsKYBPending = () => {
  const { data: KycStatusData } = useCheckStatus({ refetchOnMount: true });
  return KycStatusData?.status === KycStatus.PENDING;
};
